module.exports = __webpack_public_path__ + "ui-static/img/watermark_dark.407b4a22.svg";